<template>
  <BaseContainer>
      <BaseContentContainer>
  <h1 class="display-6 text-center mb-4">School Partnerships: Computer Science & Digital Skills</h1>

  <div class="fs-5 mb-4 text-center">
      We work in partnership with schools to deliver high-quality Computer Science education that goes beyond exam preparation. Our approach focuses on developing genuine interest, deep understanding, and strong problem-solving skills — enabling students to succeed academically while building a lasting foundation in the subject.
  </div>

  <div class="card border-success mb-4">
    <div class="card-header bg-success text-white fw-semibold">
      Our Services
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>GCSE Computer Science Intervention</strong> 
        — Targeted support to develop subject interest and deep understanding, leading to improved grades and exam confidence.</li>

      <li class="list-group-item"><strong>A-Level Computer Science Support</strong> 
        — Structured guidance covering core theory, programming and algorithms, helping students master complex topics with confidence.</li>

      <li class="list-group-item"><strong>Programming Workshops</strong> 
        — Hands-on learning experiences tailored to different ability levels, from introductory programming to more advanced applications.</li>
      
      <li class="list-group-item"><strong>Cybersecurity Enrichment</strong> 
        — Introduction to key concepts in digital security, raising awareness of real-world challenges in an increasingly connected world.</li>

      <li class="list-group-item"><strong>Algorithms & Data Structures Foundations</strong> 
        — Focused sessions on the core principles of Computer Science, strengthening problem-solving skills and computational thinking.</li>
      
      <li class="list-group-item"><strong>Computer Science Project (NEA) Support</strong> 
        — Guidance throughout the project lifecycle, including planning, development, testing, and documentation, helping students produce high-quality work independently.</li>

      <li class="list-group-item"><strong>AI & Emerging Technologies</strong> 
        — Exploring modern topics to connect to current syllabus content and computing project to inspire future careers.</li>
    
    </ul>
  </div>

  <div class="card border-0 shadow-sm mb-5 p-4">
    <h5 class="text-success">Support for Teachers</h5>
    <p class="mb-3">
      We support non-specialist teachers with resources and guidance
      to confidently deliver Computer Science lessons.
    </p>
   
  </div>

  <section class="bg-success text-white py-5">
      <div class="container text-center">
        <h4>Get in Touch</h4>
        <p class="lead">We welcome opportunities to work with schools to enhance Computer Science education
           and support student access and success.</p>
      <p class="lead">Contact us to discuss how we can tailor a partnership to your school’s needs.
        </p>
        <router-link to="/contact" class="btn btn-light mt-3 contact-button">Contact Us</router-link>
      </div>
    </section>
      </BaseContentContainer>
</BaseContainer>

</template>

<script>
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
export default {
  name: 'CoursesView',
    components: {
      BaseContainer,BaseContentContainer,
  },
}

</script>